<template>
  <div class="users">
    <header class="demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">

        <span class="mdl-layout-title">Users</span>
        <div class="mdl-layout-spacer"></div>

      </div>
    </header>

    <div class="loading-holder" v-if="!usersList">
      <h3>Loading Data...</h3>
      <div class="mdl-progress mdl-js-progress mdl-progress__indeterminate"></div>
      <h4>Please wait!</h4>
    </div>

    <div class="users-card mdl-card mdl-shadow--2dp" v-if="usersList" v-bind:class="{ blurred: state == 'working' }">
      <div class="mdl-card__supporting-text search">
        <i class="material-icons searchIcon">search</i>
        <div class="mdl-textfield mdl-js-textfield">
          <input class="mdl-textfield__input" type="text" id="search" v-model="search">
          <label class="mdl-textfield__label" for="search">Search...</label>
        </div>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">

        <div class="users-list">
          <div v-for="user in filteredUsersList">
            <router-link :to="{ name: 'user', params: { userId: user.id }}">
              <i class="material-icons user-icon">person</i>
              <span class="user-name">{{ user.display }}</span>
            </router-link>
          </div>
        </div>

      </div>
      <div class="mdl-card__actions mdl-card--border">
        <button v-on:click="addUser" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          Add empty user
        </button>
        <button v-on:click="openAddEmailPasswordDialog" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          Add user with email and password
        </button>
      </div>
    </div>

    <div v-if="addEmailPasswordDialog" class="dialog-holder">
      <div class="dialog mdl-card mdl-shadow--4dp">
        <div class="mdl-card__title mdl-color--accent" >
          <h2 class="mdl-card__title-text">Change password</h2>
          <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                  @click="() => addEmailPasswordDialog = false"><i class="material-icons">close</i></button>
        </div>
        <div class="mdl-card__supporting-text mdl-card--expand">

          <div class="mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label">
            <input class="mdl-textfield__input" type="email" id="email"
                   v-model="newEmail">
            <label class="mdl-textfield__label" for="email">New email</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label">
            <input class="mdl-textfield__input" type="text" id="pass2"
                   v-model="newPassword">
            <label class="mdl-textfield__label" for="pass2">New password</label>
          </div>

        </div>
        <div class="mdl-card__actions mdl-card--border" v-bind:class="{ blurred: state == 'saving' }">
          <a v-on:click="() => addEmailPasswordDialog = false" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            Cancel
          </a>
          <a v-on:click="addEmailPassword" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            Add email/password
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import api from "api"

  export default {
    name: 'users',
    data () {
      return {
        state: 'loading',
        addEmailPasswordDialog: false,
        newEmail: '',
        newPassword: '',
        search: ''
      }
    },
    reactive: {
      usersList: ['userAdmin', 'usersList']
    },
    computed: {
      filteredUsersList() {
        let search = this.search.trim()
        if(search.length == 0) return this.usersList
        return this.usersList.filter(user => (user.display || 'unknown').indexOf(search) != -1)
      }
    },
    watch: {
      usersList() {
        this.state = 'loaded'
      }
    },
    methods: {
      addUser() {
        this.state = 'working'
        api.request(['userAdmin', 'createUser'], 'empty').then(
          userId => {
            this.$router.push({ name:'user', params: { userId } })
          }
        )
      },
      openAddEmailPasswordDialog() {
        this.newEmail = ''
        this.newPassword = ''
        this.addEmailPasswordDialog = true
      },
      addEmailPassword() {
        this.addEmailPasswordDialog = false
        this.state = 'working'
        api.request(['userAdmin', 'createEmailUser'], this.newEmail, this.newPassword).then(
          userId => {
            this.state = 'loaded'
            this.$router.push({ name:'user', params: { userId } })
          }
        )
      }
    },
    created() {
    },
    beforeDestroy() {
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



  @media screen and (min-width: 750px) {
    .users-list {
      column-count: 2;
    }
  }

  @media screen and (min-width: 1024px) {
    .users-list {
      column-count: 3;
    }
  }

  .users-card {
    margin: 23px auto auto;
    min-height: 70vh;
    min-width: 91%;
  }

  .users-list > div {
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .users-list a {
    color: rgb(28, 105, 140);
    text-decoration: none;
  }
  .users-list a:hover {
    color: rgb(37, 149, 201);
    text-decoration: underline;
  }
  .users-list .user-icon {
    margin-right: 12px;
    vertical-align: middle;
  }
  .users-list .user-name {
  }

  .loading-holder {
    position: absolute;
    right: 0em;
    left: 0em;
    width: auto;
    top: 0em;
    bottom: 0em;
    height: auto;
    text-align: center;
  }
  .loading-holder .mdl-progress {
    margin-left: auto;
    margin-right: auto;
  }


  .blurred {
    filter: blur(2px);
  }

  .dialog-holder {
    z-index: 10;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
  }

  .dialog-holder .mdl-card__title button {
    display: block;
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-right: 0px;
    float: right;
  }
  .dialog-holder .mdl-card__title button > i {
    font-size: 20px;
  }
  .dialog {
    min-width: 30%;
    margin-left: auto;
    margin-right: auto;
  }
  .dialog .mdl-card__actions a {
    float: right;
  }

  .search {
    padding-top: 0;
    padding-bottom: 0;
  }
  .searchIcon {
    position: relative;
    top: 7px;
  }
  .search .mdl-textfield {
    width: calc(100% - 90px);
  }

</style>



// WEBPACK FOOTER //
// Users.vue?4c1bb2e2